import {assetsApi} from 'sources/api';

export class AvatarSource {
  static uploadAvatar(userId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return assetsApi.post(`/avatar/${userId}?contentLength=${file.size}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    });
  }
}
